export const stationsListFilter = (textInput, items) => {
  const shortTxt = (text) => {
    return text?.toLowerCase().replace(/\s/gi, '');
  };

  const textToLowerNoSpace = shortTxt(textInput);

  const parsedList = items?.map((station) => {
    const { chargeBoxId, description, address, externalId } = station;
    return {
      hits: {
        code:
          shortTxt(description) +
          shortTxt(String(address?.city)) +
          shortTxt(String(address?.state)) +
          shortTxt(String(chargeBoxId)) +
          shortTxt(String(externalId)), // + shortText(newFieldToBeSearchedToo)
        station,
      },
    };
  });

  return parsedList
    ?.map((item) => {
      return (
        new RegExp(textToLowerNoSpace, 'gi').test(item.hits.code) &&
        item.hits.station
      );
    })
    .filter((res) => res !== false);
};

export const stationsListTagFilter = (textInput, items) => {
  const shortTxt = (text) => {
    if (typeof text === 'string')
      return text?.toLowerCase()?.replace(/\s/gi, '');
  };

  const parsedList = items?.map((station) => {
    const { chargeBoxId, description, address, externalId } = station;
    return {
      hits: {
        code:
          shortTxt(description) +
          shortTxt(String(address?.city)) +
          shortTxt(String(address?.state)) +
          shortTxt(String(chargeBoxId)) +
          shortTxt(String(externalId)),
        station,
      },
    };
  });

  return parsedList?.length > 0
    ? parsedList
        ?.map((item) => {
          let hits = 0;
          textInput.map((text) => {
            if (new RegExp(shortTxt(text), 'gi').test(item.hits.code)) {
              hits += 1;
            }
          });

          if (hits === textInput.length) return item.hits.station;
          else return false;
        })
        .filter((res) => {
          return res !== false;
        })
    : [];
};

export const stationFilter = (
  stations,
  stationGroupInputValue,
  tenantInputValue,
  isDisabledStations,
) => {
  if (stationGroupInputValue !== '') {
    stations = stations?.filter(
      (station) =>
        station.chargeBoxGroupPk === parseInt(stationGroupInputValue),
    );
  }

  if (tenantInputValue !== '') {
    stations = stations?.filter(
      (station) => station.tenantName === tenantInputValue,
    );
  }

  stations = stations?.filter(
    (station) => station.active === !isDisabledStations,
  );

  return stations;
};

export const stationStatusFilter = (stations, statusFilter) => {
  if (!statusFilter || statusFilter === '') {
    return stations;
  }

  return stations?.filter((station) => {
    if (statusFilter === 'faulted') {
      return station.connectors?.some(
        (connector) => connector.lastStatus?.status === 'Faulted',
      );
    }
    return true;
  });
};
